import { CommonModule } from '@angular/common';
import { Component, HostListener, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { SnackBarLevel } from './snackbar.service';

@Component({
    selector: 'tm-snack',
    template: `
    <mat-icon fontSet="fa" [fontIcon]="icon" [ngClass]="iconClass"></mat-icon>
    <span [innerHtml]="data.message">
    </span>
  `,
    styleUrls: ['./snack.component.scss'],
    imports: [
        CommonModule,
        MatIconModule
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    host: {
        'class': 'tm-snack',
    }
})
export class SnackComponent {

  @HostListener('click')
  click = () => this.snackBarRef.dismiss();

  icon = this.data.level === 'error' ? 'fa-circle-exclamation' : 'fa-circle-check';
  iconClass = `${this.data.level}`

  constructor(
    @Inject(MatSnackBarRef) protected snackBarRef: MatSnackBarRef<SnackComponent>,
    @Inject(MAT_SNACK_BAR_DATA) protected data: { message: string; level: SnackBarLevel }
  ) { }
}